import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "47.794",
  width: "50",
  viewBox: "0 0 50 47.794",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    fill: "#b0171d",
    d: "M50 9.314l-1.47 36.274-10.54-18.382L50 9.314zM33.333.49L48.04 0l1.715 6.618L33.333.49zm2.45 29.412L46.57 47.794l-33.09-2.94L35.784 29.9zm-17.646-6.127l13.726 4.656-16.667 11.03 2.94-15.682zm-14.95 2.94l5.146 18.138L0 43.383l3.186-16.667zm27.205-15.44L47.06 8.58 36.274 24.755l-5.883-13.48zm-.735-9.314c1.716 1.965-2.206 8.58-9.314 14.71-6.863 6.127-13.97 9.313-15.686 7.108-1.716-1.96 2.206-8.58 9.314-14.706 6.866-6.13 13.97-9.315 15.69-7.11zm-9.56 18.877l12.5 3.922-4.656-11.52s-2.202 4.165-7.84 7.597zm10.54-12.01l10.294-1.96L32.6 3.92s0 2.696-1.96 4.902zM7.597 27.942l3.678 11.52 2.94-13.48c0 .244-3.43 2.695-6.616 1.96z"
  })]
});